import { CreateOperatorProvider } from '../../contexts/CreateOperatorContext';
import { Form } from './Form';
import { Results } from './Results';

export const CreateOperator = () => (
  <CreateOperatorProvider>
    <Form />
    <Results />
  </CreateOperatorProvider>
);
